/**
 * 다음(Daum) 주소찾기의 결과값에서 원하는 형태의 주소(address1)로 변환
 * @param data - 주소 정보 객체. 'react-daum-postcode/lib/loadPostcode'의 Address 타입
 */
export const transformAddressFromDaum = (data: {
  zonecode: string;
  address: string;
  addressEnglish: string;
  addressType: "R" | "J";
  userSelectedType: "R" | "J";
  noSelected: "Y" | "N";
  userLanguageType: "K" | "E";
  roadAddress: string;
  roadAddressEnglish: string;
  jibunAddress: string;
  jibunAddressEnglish: string;
  autoRoadAddress: string;
  autoRoadAddressEnglish: string;
  autoJibunAddress: string;
  autoJibunAddressEnglish: string;
  buildingCode: string;
  buildingName: string;
  apartment: "Y" | "N";
  sido: string;
  sidoEnglish: string;
  sigungu: string;
  sigunguEnglish: string;
  sigunguCode: string;
  roadnameCode: string;
  bcode: string;
  roadname: string;
  roadnameEnglish: string;
  bname: string;
  bnameEnglish: string;
  bname1: string;
  bname1English: string;
  bname2: string;
  bname2English: string;
  hname: string;
  query: string;
}): string => {
  const roadAddress = data.roadAddress.split(" ");
  return roadAddress.filter((value) => value !== data.sido).join(" ");
};

/**
 * Daum 주소 검색 sido 한글 값을 shopify 영문으로 변경.
 * shopify에 저장하기 위해 사용.
 */
export const ProvinceNameEnMap: Record<string, keyof typeof ProvinceNameKoMap> = {
  부산: "Busan",
  충북: "Chungbuk",
  충남: "Chungnam",
  대구: "Daegu",
  대전: "Daejeon",
  강원특별자치도: "Gangwon",
  광주: "Gwangju",
  경북: "Gyeongbuk",
  경기: "Gyeonggi",
  경남: "Gyeongnam",
  인천: "Incheon",
  제주특별자치도: "Jeju",
  전북특별자치도: "Jeonbuk",
  전남: "Jeonnam",
  세종특별자치시: "Sejong",
  서울: "Seoul",
  울산: "Ulsan",
};

/**
 * shopify 영문값을 UI 노출하는 한글로 변경
 */
export const ProvinceNameKoMap: Record<string, string> = {
  Busan: "부산광역시",
  Chungbuk: "충청북도",
  Chungnam: "충청남도",
  Daegu: "대구광역시",
  Daejeon: "대전광역시",
  Gangwon: "강원특별자치도",
  Gwangju: "광주광역시",
  Gyeongbuk: "경상북도",
  Gyeonggi: "경기도",
  Gyeongnam: "경상남도",
  Incheon: "인천광역시",
  Jeju: "제주특별자치도",
  Jeonbuk: "전북특별자치도",
  Jeonnam: "전라남도",
  Sejong: "세종특별자치시",
  Seoul: "서울특별시",
  Ulsan: "울산광역시",
};

/**
 * 카카오 한글값을 영어로 변경
 */
export const ProvinceNameFullEnMap: Record<string, string> = {
  부산광역시: "Busan",
  충청북도: "Chungbuk",
  충청남도: "Chungnam",
  대구광역시: "Daegu",
  대전광역시: "Daejeon",
  강원특별자치도: "Gangwon",
  광주광역시: "Gwangju",
  경상북도: "Gyeongbuk",
  경기도: "Gyeonggi",
  경상남도: "Gyeongnam",
  인천광역시: "Incheon",
  제주특별자치도: "Jeju",
  전북특별자치도: "Jeonbuk",
  전라남도: "Jeonnam",
  세종특별자치시: "Sejong",
  서울특별시: "Seoul",
  울산광역시: "Ulsan",
};
